import { getServerUrl } from '../../utils/serverUrl';

export async function createTmpDir(): Promise<{ dir: string; file: string }> {
  try {
    const res = await fetch(getServerUrl('tmpDir'), {
      method: "get",
    });
    return await res.json();
  } catch (error) {
    throw new Error(`${String(error)}`);
  }
}
export async function getVersion(): Promise<string> {
  try {
    const res = await fetch(getServerUrl('version'), {
      method: "get",
    });
    if (res?.status === 404) {
      return "0-0-0";
    } else if (res.status === 500) {
      return "";
    }
    return (await res.json()).version;
  } catch (error) {
    throw new Error(`${String(error)}`);
  }
}

export async function deleteTmpDir(tmpDir: string): Promise<number> {
  // renderStore.filesFolderPath defaults to "" and is only set once a temp dir
  // has actually been created, so a render that ends without one calls this
  // with an empty path. There is nothing to delete — skip the round trip.
  if (!tmpDir) {
    console.warn("deleteTmpDir called with an empty path — nothing to remove");
    return 0;
  }
  try {
    const res = await fetch(getServerUrl('tmpDir'), {
      method: "delete",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ tmpDir: tmpDir }),
    });
    return res.status;
  } catch (error) {
    throw new Error(`${String(error)}`);
  }
}

export async function clearCache() {
  try {
    const res = await fetch(getServerUrl('clearCache'), {
      method: "DELETE",
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return await res.text(); // Or return res.json() if the server responds with JSON
  } catch (error) {
    throw new Error(`${error as string}`);
  }
}
